
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {AracUzerindekiYakalamaSerhininKaldirilmasiTalep} from "@/interface/IUyapTalep";
import Plaka from "@/components/inputs/Plaka.vue";

@Component({
  components: {Plaka}
})
export default class AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm extends Mixins(ObjectInputMixin) {
  localValue!: AracUzerindekiYakalamaSerhininKaldirilmasiTalep;
}
